import {gql} from "@apollo/client";

export const GET_NUMBERPLATE_CHECK = gql`
    query getNumberPlateCheck($organization: ID!, $numberPlate: String!, $service: ID!) {
        numberPlateCheck(organization_id: $organization, number_plate: $numberPlate, service_id: $service) {
            status
        }
    }
`
